import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconComment = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "#4D4540",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14 5.198c0 2.87-3.134 5.198-7 5.198a9.42 9.42 0 0 1-1.213-.078c-.554-.072-2.52 2.192-3.547 1.575-.56-.44 1.02-2.29.689-2.466C1.155 8.484 0 6.94 0 5.197 0 2.328 3.134 0 7 0s7 2.327 7 5.198Z" })
});
export default SvgIconComment;
